import type { ContentView } from 'dfx/edge/edge.did';

export const isSelfPost = (post: ContentView) => {
  return 'User' in post.portal.portal_type;
};
